<template>
  <div class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t("map.breadcrumb_1")}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-3 almarai-bold" aria-current="page">
          {{$t("map.breadcrumb_2")}}
        </li>
      </ol>
    </nav>
  </div>

  <div class="container pt-3">
    <div v-if="!accessLocation" class="row justify-content-center mb-5 mt-5">
      <div class="col-12 col-sm-8">
        <div class="alert alert-warning">{{ $t('map.accessLocation') }}</div>
      </div>
    </div>
    <div class="text-center" v-if="accessLocation && (isLoading || dataLoading)">
      <mainloader />
    </div>
    <div v-if="accessLocation && !isLoading && !dataLoading" class="row">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber"/>
        <div class="row scroll-row mb-3">
          <div :class="(category == 'commercial')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="commercial">
            <input class="form-check-input" type="radio" name="radioDefault" value="commercial" 
              v-model="category" id="commercial" @change="nearProperties"
            >
              <img :src="(category == 'commercial') ?'/assets/images/icons/shop-white.png':'/assets/images/icons/shop.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('commercial')}}</span>
            </label>
          </div>
          <div :class="(category == 'residential')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="resident">
            <input class="form-check-input" type="radio" name="radioDefault" value="residential" 
              v-model="category" id="resident" @change="nearProperties"
            >
              <img :src="(category == 'residential') ? '/assets/images/icons/building-white.png':'/assets/images/icons/building-4.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('residential')}}</span>
            </label>
          </div>
          <div :class="(purpose == 'for_rent')? 'col-auto category balck-bg':' col-auto category'">
            <label class="form-check-label mouse-hand" for="radioDefault1">
            <input class="form-check-input" type="radio" value="for_rent" 
              v-model="purpose" name="radioDefault" id="radioDefault1" @change="nearProperties"
            >
              <span>{{$t("map.btnRent")}}</span>
            </label>
          </div>
          <div :class="(purpose == 'for_sale')? 'col-auto category balck-bg':'col-auto category'">
            <label class="form-check-label mouse-hand" for="radioDefault2">
            <input class="form-check-input" type="radio" name="radioDefault" value="for_sale" 
              v-model="purpose" id="radioDefault2" @change="nearProperties"
            >
              <span>{{$t("map.btnSale")}}</span>
            </label>
          </div>
          <div class="col-auto categoryStyle">
            <label class="form-check-label mouse-hand" @click="clearFilter()">
              <span class="mx-2">{{$t("map.btnAll")}}</span>
            </label>
          </div>

          <!-- <div :class="(purpose == 'for_investment')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="Investment">
            <input class="form-check-input" type="radio" name="radioDefault" value="for_investment" 
              v-model="purpose" id="Investment" @change="nearProperties"
            >
              <span>{{$t("investment")}}</span>
            </label>
          </div> -->
        </div>

        <div class="row pt-2 scroll-row">
          <!-- <div class="col-auto">
            <div @click="setType(null)" :class="(fildType == null)? 'categoryAll balck-bg':'categoryAll'">
              <label class="form-check-label mouse-hand" for="all">
              <input class="form-check-input" type="radio" name="radioDefault" value="null" 
                v-model="purpose" id="all"
              >
                <span>{{$t("map.btnAll")}}</span>
              </label>
            </div>
          </div> -->
          <div class="col-auto mb-3 scroll-col" v-for="(row,indx) in types" :key="indx">
            <div @click="setType(row.id)" :class="(fildType == row.id) ? 'filter-buttons balck-bg mouse-hand': 'filter-buttons mouse-hand'">
              <span class="showIcon">
                <img :src="MEDIA_URL+row.icon" class="w-24" alt="">
              </span>
              <span class="mx-2">{{ row.name }}</span>
            </div>
          </div>
        </div>

        <div class="row py-5">
          <div class="col position-R">
            <div class="almarai-bold font-20 py-2">{{$t('map.title')}}</div>
            <div ref="myMap" style="width: 100%; height: 560px;"></div>
            <span v-if="active" @click="removeActive" class="mouse-hand"><i class="fa-solid fa-heart favorite-Active"></i></span>
            <span v-else @click="favoriteFN" class="mouse-hand"><i class="fa-solid fa-heart favorite-Maps"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'maps',
  data(){
    return {
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: false,
      dataLoading: true,
      types: [],
      fildType: null,
      latitude: 24.7136,
      longitude: 46.6753,
      rows:[],
      icons: {},
      active: false,
      userLang: 'ar',
      purpose: "null",
      accessLocation: true,
      category: "",
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    getDataInit(){
      this.hasError = false;
      this.$http.get("/api/properties/init").then(res => {
        // console.log(res);
        this.types = res.data.typesList;
        this.dataLoading = false;  
        window.scroll(0,0);
      }).catch(err => {
        // console.log(err);
        this.dataLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    nearProperties(){
      this.hasError = false;
      this.$http.get("/api/properties/nearYou?latitude="+this.latitude+'&'+'longitude='+this.longitude+'&'+'typeId='+this.fildType+'&'+'purpose='+this.purpose+'&'+'category='+this.category).then(res => {
        // console.log(res);
        this.rows = res.data.properties;
        this.icons = res.data.countedIcons;
        this.initialGoogleMap();
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    clearFilter(){
      this.category = "";
      this.purpose = "";
      this.fildType = null;
      this.nearProperties();
    },

    favoriteFN(){
      this.$http.get("/api/properties/nearYou?latitude="+this.latitude+'&'+'longitude='+this.longitude+'&'+'favorites=yes').then(res => {
        this.rows = res.data.properties;
        this.icons = res.data.countedIcons;
        this.initialGoogleMap();
        this.active = true;
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    removeActive(){
      this.active =false;
      this.nearProperties();
    },

    setType(id){
      this.fildType = id;
      this.nearProperties();
    },

    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
            this.nearProperties();
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
            // this.getData();
            this.accessLocation = false;
          }
        );
      } else {
        // this.error = "Geolocation is not supported by this browser.";
        // this.getData();
        this.accessLocation = false;
      }
    },
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      if (this.someObject && this.someObject.backdrop) {
          this.someObject.backdrop.show();
      }
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      
      // Create a Marker
      const markers = [];
      const infoWindow = [];
      for (let index = 0; index < this.rows.length; index++) {
        const element = this.rows[index];
        if(!parseFloat(element.latitude)|| !parseFloat(element.longitude)){
          continue;
        }

        markers[index] = new google.maps.Marker({
          
          position: { 
            lat: (element.latitude)? parseFloat(element.latitude) : 24.7136, 
            lng: (element.longitude) ? parseFloat(element.longitude) : 46.6753, 
          },
          map: this.map,
          draggable: false, // Allow dragging the marker
          icon: {
            url: (element.Favorites && element.Favorites.length) ? '/assets/images/icons/gps_1_white.png' : "/assets/images/icons/gps_white.png", // Custom marker image
            scaledSize: new google.maps.Size(40, 40), // Resize image if needed
          },
        });
        let imgdiv = '';
        if(element.mediaFiles.length){
          imgdiv = ` <div  class="col-5 col-md-6 content-center text-center ps-4">
            <img src="${this.MEDIA_URL}${element.mediaFiles[0].thumbnail}" class="w-100 br-radius"> </div>`
        }
          
        let infoContent = `
            <a href=/propertydetails/${element.id}>
              <div class="row pb-3">
                <div class="col-7 col-md-5 content-center">
                  <h6 class="almarai-regular">${element.title}</h6> 
                  <h6 class="price py-1">
                    <span>${element.price}</span>
                    <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                  </h6>
          `;
        if(element.area){
          infoContent += `
            <img src="${this.MEDIA_URL}${this.icons.area.path}" class="max-width-28 ms-1">
            <span class="icons-Padding">${element.area}</span>
            <span>متر</span>
          `;
        }
        if(element.roomsCount){
          infoContent += `
            <img src="${this.MEDIA_URL}${this.icons.roomsCount.path}" class="max-width-28 mx-1">
            <span class="icons-Padding">${element.roomsCount}</span>
          `;
        }
        if(element.bathrooms){
          infoContent += `
            <img src="${this.MEDIA_URL}${this.icons.bathrooms.path}" class="max-width-28 mx-1">
            <span class="icons-Padding">${element.bathrooms}</span>
          `;
        }
        if(element.City && element.Neighborhood){
          infoContent += `
              <h6 class="location pt-2 me-1">
                <i class="fa-solid fa-location-dot"></i>
                <span>${element.Neighborhood.name}</span>
                <span>${element.City.name}</span>
              </h6>
              </div>
                ${imgdiv}
              </div>
            </a>
          `;
        }
        infoWindow[index] = new google.maps.InfoWindow({
          content: infoContent,
          
        });
        markers[index].addListener("click", () => {
          const elements = document.getElementsByClassName("gm-ui-hover-effect");
          if(elements){
            Array.from(elements).forEach(element => {
              element.click();
            });
          }
          infoWindow[index].open(this.map, markers[index]);
        });
      }
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    setPurpose(purp){
      this.purpose = purp;
      this.nearProperties();
    }
  },

  created(){
    this.getDataInit();
    // this.getLocation();
    this.isLoading = true;
    this.nearProperties();
    // if(window.getComputedStyle(document.getElementById("mobNavBtn"),null).getPropertyValue('display') == 'block' && window.getComputedStyle(document.getElementById("navbarNavDropdown"),null).getPropertyValue('display') == 'block'){
    //   document.getElementById("mobNavBtn").click();
    // }
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>